// extracted by mini-css-extract-plugin
export default {"empty_block":"EmptyPage_empty_block__uz5I7"};